import React, { useEffect, useState } from "react";
import { useAxiosContext } from "../../context/AxiosContext";
import { useParams } from "react-router-dom";
import Button from "../../components/FormComponents/Button";
import CodeEditor from "../../components/BuilderComponents/CodeEditor/CodeEditor";

const CustomJsAndCssForScreen = ({ onClose }) => {
  const [customValues, setCustomValues] = useState({
    custom_js: "",
    custom_css: ""
  });
  const { axiosInstance, handleError, handleSuccess } = useAxiosContext();
  const { screenId } = useParams();

  const handleSaveCustomValues = async () => {
    try {
      const { message } = await axiosInstance.put(`/page_assets/${screenId}`, customValues);
      handleSuccess(message);
      onClose();
    } catch (error) {
      handleError(error);
    }
  };
  const getCustomValues = async () => {
    try {
      const { data } = await axiosInstance.get(`/page_assets/${screenId}`);
      setCustomValues({
        custom_js: data.custom_js,
        custom_css: data.custom_css
      });
    } catch (error) {
      // handleError(error);
    }
  };
  const handleTextAreaChange = (customKey, value) => {
    setCustomValues((prev) => ({
      ...prev,
      [customKey]: value
    }));
  };
  useEffect(() => {
    getCustomValues();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="builder_form h_100">
      <div className="custom_wrapper mb_5">
        <div className="w_100 h_100">
          <h3 className="p_1">Java Script</h3>
          <CodeEditor
            height="100%"
            containerClass={"w_100 h_100"}
            value={customValues.custom_js}
            handleChange={(code) => handleTextAreaChange("custom_js", code)}
            enableBacktickTrigger={false}
          />
        </div>

        <div className="w_100 h_100">
          <h3 className="p_1">CSS</h3>
          <CodeEditor
            height="100%"
            containerClass={"w_100 h_100"}
            language="css"
            value={customValues.custom_css}
            handleChange={(code) => handleTextAreaChange("custom_css", code)}
            enableBacktickTrigger={false}
          />
        </div>
      </div>

      <div className="d_flex w_100 justify_end">
        <Button style={{ width: "fit-content" }} onClick={handleSaveCustomValues}>
          Save
        </Button>
      </div>
    </div>
  );
};

export default CustomJsAndCssForScreen;
